import { render } from "./ai-dictionary-virtual-grid.vue?vue&type=template&id=ff3c92a8"
import script from "./ai-dictionary-virtual-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-dictionary-virtual-grid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/dictionary-components/ai-dictionary-virtual-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff3c92a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff3c92a8', __exports__)) {
    api.reload('ff3c92a8', __exports__)
  }
  
  module.hot.accept("./ai-dictionary-virtual-grid.vue?vue&type=template&id=ff3c92a8", () => {
    api.rerender('ff3c92a8', render)
  })

}


export default __exports__